import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a732f43"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entrySchedule" }
const _hoisted_2 = { class: "queryForm" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "入荷予定（日本倉庫）", -1))
const _hoisted_4 = { class: "tableLayout" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("入荷注文のエクスポート")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("キャンセル")
const _hoisted_7 = {
  key: 0,
  class: "loadingBar flex-ter"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"24px","height":"24px","margin-right":"8px"},
  src: "https://static-s.theckb.com/BusinessMarket/Client/userCenter/icon_speaker.png",
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" インポート中です。しばらくして再読み込みしてください ")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "入荷予定伝票", -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]

import { t } from '@/plugins/i18n'
import { setDefaultForm, clearForm } from '@/util/common'
import { cloneDeep } from 'lodash'
import { computed, ref, toRaw, nextTick, onMounted } from 'vue'
import STable from '@/components/Table/index.vue'
import { request } from '@/config/request/interceptors'
import { statusList, entryListColumns, statusMap, StatuEnum, statusMapType } from './data'
import { TransferInboundPageDTO } from '@/service/overseas'
import { ElMessage, ElMessageBox } from 'element-plus'
import UploadFileModal from './components/uploadFileModal.vue'
import NewInputBatchSearch from '@/components/NewInputBatchSearch/index.vue'
import router from '@/router'
import { useRtfix } from '@/store'
import dayjs from 'dayjs'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const STableRef = ref()
const uploadLoading = ref(false)
const queryForm = ref()
const pageData = ref({
  page: 1,
  limit: 20
})

const hasNoPending = computed(() => selectedOrderList.value.some(i => i.status !== StatuEnum.PENDING_STORAGE))
/** 刷新表单 */
const refreshTable = (type?: boolean) => {
  if (type) {
    pageData.value = {
      page: 1,
      limit: 20
    }
  }
  nextTick(() => {
    STableRef.value && STableRef.value.getData()
  })
}

const defaultForm = {
  orderTimeStart: '',
  orderTimeEnd: '',
  productSkuList: []
}
const getForm = (form: any) => setDefaultForm(cloneDeep(toRaw(form)), defaultForm)
const _form = ref(getForm({}))
const selectedOrderList = ref<TransferInboundPageDTO[]>([])

const searchDate = computed({
  get: () =>
    [_form.value.orderTimeStart, _form.value.orderTimeEnd],
  set: (newVal) => {
    [_form.value.orderTimeStart, _form.value.orderTimeEnd] = newVal ?? []
  }
})

onMounted(() => {
  refreshTable()
})

/** 取消订单 */
const cancelOrder = (inboundCodeList: string[]) => {
  ElMessageBox.confirm('この入荷依頼をキャンセルしてもよろしいですか？', t('提示'), {
    confirmButtonText: t('确定'),
    cancelButtonText: t('取消'),
    type: 'warning'
  })
    .then(async () => {
      const res = await request.overseas.overseasWms.transferInboundCancel({
        inboundCodeList
      })
      ElMessage.success(t('操作成功'))
      refreshTable()
    })
}

/** 查看订单详情 */
const seeDetail = (item: TransferInboundPageDTO) => {
  router.push(useRtfix('EntryInfo', { params: { inboundCode: item.inboundCode } }))
}

// 选择table行
const handleSelectionChange = (val: TransferInboundPageDTO[]) => {
  selectedOrderList.value = val
}
const loading = ref(false)

/** 导出订单 */
const hanleExport = async () => {
  loading.value = true
  try {
    const res: any = await request.overseas.overseasWms.transferInboundClientExport({
      inboundCodeList: selectedOrderList.value.map(i => i.inboundCode!)
    }, {
      format: 'blob'
    })
    const fileName = `入荷依頼＿${new Date().toISOString().split('T')[0]}.csv`
    const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
    const objectUrl = URL.createObjectURL(blob)
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.setAttribute('style', 'display:none')
    a.setAttribute('href', objectUrl)
    a.setAttribute('download', fileName)
    a.click()
    URL.revokeObjectURL(objectUrl)
    ElMessage.success(t('导出成功'))
  } catch (error) {

  } finally {
    loading.value = false
  }
}

/** 取消订单 */
const handleCancel = async () => {
  cancelOrder(selectedOrderList.value.map(i => i.inboundCode!))
}

/** 搜索 */
const submit = () => {
  queryForm.value = cloneDeep({
    ..._form.value,
    orderTimeStart: searchDate.value[0] ? dayjs(searchDate.value[0]).add(-1, 'days').format('YYYY-MM-DD 23:00:00') : '',
    orderTimeEnd: searchDate.value[1] ? `${searchDate.value[1]} 22:59:59` : ''
  })
  refreshTable(true)
}

const reset = () => {
  clearForm(_form.value)
  _form.value.productSkuList = undefined
  queryForm.value = cloneDeep(_form.value)
  refreshTable(true)
}

// const columns = ref()

const tableConfig = {
  showSelection: true,
  // rowKey: 'id',
  setHeight: true,
  selectable: (row: any) => row
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_form, {
        class: "form",
        model: _form.value,
        "label-position": "top",
        inline: true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "入库单号",
            class: "w-260"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _form.value.inboundCode,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_form.value.inboundCode) = $event)),
                placeholder: _unref(t)('请输入')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: _unref(t)('商品编码')
          }, {
            default: _withCtx(() => [
              _createVNode(NewInputBatchSearch, {
                class: "w-260",
                modelValue: _form.value.productSkuList,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_form.value.productSkuList) = $event)),
                placeholder: _unref(t)('双击批量搜索')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: "発注コード",
            class: "w-260"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _form.value.customerInboundCode,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_form.value.customerInboundCode) = $event)),
                placeholder: _unref(t)('请输入')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "発注日",
            class: "w-260"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _unref(searchDate),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(searchDate) ? (searchDate).value = $event : null)),
                type: "daterange",
                "range-separator": "-",
                "start-placeholder": _unref(t)('开始时间'),
                "end-placeholder": _unref(t)('结束时间'),
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "仕入先",
            class: "w-260"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _form.value.supplierName,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_form.value.supplierName) = $event)),
                placeholder: _unref(t)('请输入')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "倉庫の状況",
            class: "w-260"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _form.value.status,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_form.value.status) = $event)),
                placeholder: _unref(t)('请选择'),
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statusList), (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.label,
                      value: item.value,
                      key: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: '',
            style: {"margin-top":"30px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: submit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, { onClick: reset }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_space, null, {
        default: _withCtx(() => [
          _createVNode(UploadFileModal, {
            loading: uploadLoading.value,
            "onUpdate:loading": _cache[6] || (_cache[6] = ($event: any) => ((uploadLoading).value = $event)),
            onUpdateSuccess: _cache[7] || (_cache[7] = ($event: any) => (refreshTable(true)))
          }, null, 8, ["loading"]),
          _createVNode(_component_el_button, {
            loading: loading.value,
            disabled: !selectedOrderList.value?.length || loading.value,
            onClick: hanleExport
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["loading", "disabled"]),
          _createVNode(_component_el_button, {
            disabled: !selectedOrderList.value?.length || _unref(hasNoPending),
            onClick: handleCancel
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }),
      (uploadLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
        : _createCommentVNode("", true),
      _createVNode(STable, {
        class: "table",
        ref: (_value, _refs) => {
          _refs['STableRef'] = _value
          STableRef.value = _value
        },
        "page-data": pageData.value,
        "onUpdate:page-data": _cache[8] || (_cache[8] = ($event: any) => ((pageData).value = $event)),
        api: _unref(request).overseas.overseasWms.transferInboundClientPage,
        filterData: queryForm.value,
        columns: _unref(entryListColumns),
        tableConfig: tableConfig,
        onSelectionChange: handleSelectionChange
      }, {
        inboundCodeSlot: _withCtx(({ row }) => [
          _createElementVNode("a", {
            type: "primary",
            onClick: ($event: any) => (seeDetail(row))
          }, _toDisplayString(row.inboundCode), 9, _hoisted_11)
        ]),
        customerInboundCodeSlot: _withCtx(({ row }) => [
          _createElementVNode("a", {
            type: "primary",
            onClick: ($event: any) => (seeDetail(row))
          }, _toDisplayString(row.customerInboundCode), 9, _hoisted_12)
        ]),
        orderTimeSlot: _withCtx(({ row }) => [
          _createElementVNode("div", null, _toDisplayString(_unref(dayjs)(row.orderTime).add(1, 'hour').format('YYYY-MM-DD HH:mm:ss')), 1)
        ]),
        inboundTypeSlot: _withCtx(({ row }) => [
          _hoisted_13
        ]),
        receiverWarehouseSlot: _withCtx(({ row }) => [
          _createElementVNode("div", null, _toDisplayString(row.receiverWarehouse), 1),
          _createElementVNode("div", null, [
            (_unref(StatuEnum).PENDING_STORAGE === row.status && row.createTime)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: _unref(statusMapType)[_unref(StatuEnum).PENDING_STORAGE]
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(dayjs)(row.createTime).add(1,
                'hour').format('YYYY-MM-DD HH:mm:ss')) + " " + _toDisplayString(_unref(statusMap)[_unref(StatuEnum).PENDING_STORAGE]), 1)
                  ]),
                  _: 2
                }, 1032, ["type"]))
              : _createCommentVNode("", true),
            (_unref(StatuEnum).IN_STORAGE === row.status && row.signTime)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: _unref(statusMapType)[_unref(StatuEnum).IN_STORAGE]
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(dayjs)(row.signTime).add(1,
                'hour').format('YYYY-MM-DD HH:mm:ss')) + " " + _toDisplayString(_unref(statusMap)[_unref(StatuEnum).IN_STORAGE]), 1)
                  ]),
                  _: 2
                }, 1032, ["type"]))
              : _createCommentVNode("", true),
            (_unref(StatuEnum).COMPLETED === row.status && row.completeTime)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 2,
                  type: _unref(statusMapType)[_unref(StatuEnum).COMPLETED]
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(dayjs)(row.completeTime).add(1,
                'hour').format('YYYY-MM-DD HH:mm:ss')) + " " + _toDisplayString(_unref(statusMap)[_unref(StatuEnum).COMPLETED]), 1)
                  ]),
                  _: 2
                }, 1032, ["type"]))
              : _createCommentVNode("", true),
            (_unref(StatuEnum).CANCELED === row.status && row.closeTime)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 3,
                  type: _unref(statusMapType)[_unref(StatuEnum).CANCELED]
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(dayjs)(row.closeTime).add(1,
                'hour').format('YYYY-MM-DD HH:mm:ss')) + " " + _toDisplayString(_unref(statusMap)[_unref(StatuEnum).CANCELED]), 1)
                  ]),
                  _: 2
                }, 1032, ["type"]))
              : _createCommentVNode("", true)
          ])
        ]),
        actionSlot: _withCtx(({ row }) => [
          _createVNode(_component_el_space, null, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "opt-btn",
                onClick: ($event: any) => (seeDetail(row))
              }, "詳細", 8, _hoisted_14),
              (row.status === _unref(StatuEnum).PENDING_STORAGE)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "opt-btn",
                    onClick: ($event: any) => (cancelOrder([row.inboundCode!]))
                  }, "キャンセル", 8, _hoisted_15))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["page-data", "api", "filterData", "columns"])
    ])
  ]))
}
}

})